import React, { useContext, useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import getDenomination from "../../utilities/getDenomination";
import getClassName from "../../utilities/getClassName";
import headRoom from "../../assets/icons/head-room.svg";
import cabinCrew from "../../assets/icons/cabin-crew-dark.svg";
import seats from "../../assets/icons/seats.svg";
import luggage from "../../assets/icons/luggage-dark.svg";
import carbonEmissions from "../../assets/icons/co2.svg";
import toilet from "../../assets/icons/toilet-dark.svg";
import catering from "../../assets/icons/catering-alt-dark.svg";
import wifi from "../../assets/icons/wifi-dark.svg";
import tick from "../../assets/icons/tick.svg";
import cross from "../../assets/icons/cross.svg";
import { useNavigate } from "react-router-dom";
import Button from "../ui/Button";
import QuoteCtaBar from "./QuoteCtaBar";
import Share from "../flight-brief/Share";
import Modal from "../ui/Modal";
import poweredByContext from "../../store/PoweredByContext";

import pilots from "../../assets/icons/pilots-dark.svg";
import subjectToWeight from "../../assets/icons/subject-to-weight-dark.svg";
import refurbished from "../../assets/icons/refurbished-dark.svg";
import cabinWidth from "../../assets/icons/cabin-width-dark.svg";
import cabinLength from "../../assets/icons/cabin-length-dark.svg";
import smoking from "../../assets/icons/smoking-dark.svg";
import pets from "../../assets/icons/pets-dark.svg";
import subjectToConditions from "../../assets/icons/subject-to-conditions-dark.svg";
import fuelStop from "../../assets/icons/fuel-stop-dark.svg";
import ownerApproval from "../../assets/icons/owner-approval-dark.svg";
import flightManufacture from "../../assets/icons/flight-manufacture.svg";

const Compare = ({ aircraftData, compareSelection, legId, clearAllHandler, sharedPage, backLink }) => {
    const [showSharePanel, setShowSharePanel] = useState(false);
    const [tailNumbers, setTailNumbers] = useState([]);

    const poweredByCtx = useContext(poweredByContext);
    const navigate = useNavigate();

    const selectedFlights = [];

    compareSelection.map((chosenFlight) => {
        chosenFlight = chosenFlight.split("___");
        const addThis = aircraftData.filter(
            (aircraft) => aircraft.id === chosenFlight[0] && aircraft.tailNumber === chosenFlight[1]
        )[0];
        selectedFlights.push(addThis);
        return false;
    });

    const getShareRef = () => {
        let shareRef = [];

        compareSelection.forEach((item) => {
            item = item.split("___");
            shareRef.push(item[0]);
        });

        return shareRef;
    };

    const getTailNumbers = () => {
        let flightTailNumbers = [];

        selectedFlights.forEach((flight) => {
            flightTailNumbers = tailNumbers;
            flightTailNumbers.push(flight.tailNumber);
        });

        return flightTailNumbers;
    };

    if (selectedFlights.length > 0 && tailNumbers.length === 0) {
        setTailNumbers(getTailNumbers());
    }

    let link = `/quote${backLink}`;
    if (sharedPage) {
        link = `/shared-quote${backLink}`;
    }

    const navigateBackToQuoteHandler = () => {
        clearAllHandler();
        navigate(link);
    };

    useEffect(() => {
        if (!compareSelection.length) {
            navigate(link);
        }
    }, [compareSelection.length, link, navigate]);

    return (
        <>
            <div className="compare">
                <QuoteCtaBar
                    page="compare"
                    compareSelection={compareSelection}
                    legId={legId}
                    clearAllHandler={clearAllHandler}
                    showShare={() => setShowSharePanel(true)}
                    sharedPage={sharedPage}
                    backLink={backLink}
                />

                <div className="compare__scroll-wrapper">
                    <div className="compare__table-fixed-header">
                        <div className="compare__table-backgrounds">
                            <div className="compare__table-backgrounds__background1" />
                            <div className="compare__table-backgrounds__background2" />

                            <div className="compare__table">
                                <div className="compare__table__cell compare__table__cell--title">Aircraft Type</div>
                                <div title="Manufactured" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Manufactured</div>
                                    <img src={flightManufacture} alt="" />
                                </div>
                                <div title="Refurbished" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Refurbished</div>
                                    <img src={refurbished} alt="" />
                                </div>
                                <div
                                    title="Seating Capacity"
                                    className="compare__table__cell compare__table__cell--header"
                                >
                                    <div className="compare__table__cell__text">Seating Capacity</div>
                                    <img src={seats} alt="" />
                                </div>
                                <div title="Fuel Stop" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Fuel Stop</div>
                                    <img src={fuelStop} alt="" />
                                </div>
                                <div title="Luggage" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Luggage</div>
                                    <img src={luggage} alt="" />
                                </div>
                                <div title="Catering" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Catering</div>
                                    <img src={catering} alt="" />
                                </div>
                                <div title="WC" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">WC</div>
                                    <img src={toilet} alt="" />
                                </div>
                                <div
                                    title="Owner Approval"
                                    className="compare__table__cell compare__table__cell--header"
                                >
                                    <div className="compare__table__cell__text">Owner Approval</div>
                                    <img src={ownerApproval} alt="" />
                                </div>
                                <div title="WiFi" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">WiFi</div>
                                    <img src={wifi} alt="" />
                                </div>
                                <div title="Pilots" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Pilots</div>
                                    <img src={pilots} alt="" />
                                </div>
                                <div
                                    title="Flight Attendant"
                                    className="compare__table__cell compare__table__cell--header"
                                >
                                    <div className="compare__table__cell__text">Flight Attendant</div>
                                    <img src={cabinCrew} alt="" />
                                </div>
                                <div title="Pets" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Pets</div>
                                    <img src={pets} alt="" />
                                </div>
                                <div title="Smoking" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Smoking</div>
                                    <img src={smoking} alt="" />
                                </div>
                                <div title="CO₂" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">CO₂</div>
                                    <img src={carbonEmissions} alt="" />
                                </div>
                                <div
                                    title="Subject to Conditions"
                                    className="compare__table__cell compare__table__cell--header"
                                >
                                    <div className="compare__table__cell__text">Subject to Conditions</div>
                                    <img src={subjectToConditions} alt="" />
                                </div>
                                <div
                                    title="Subject to Weight"
                                    className="compare__table__cell compare__table__cell--header"
                                >
                                    <div className="compare__table__cell__text">Subject to Weight</div>
                                    <img src={subjectToWeight} alt="" />
                                </div>
                                <div title="Cabin Height" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Cabin Height</div>
                                    <img src={headRoom} alt="" />
                                </div>
                                <div title="Cabin Width" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Cabin Width</div>
                                    <img src={cabinWidth} alt="" />
                                </div>
                                <div title="Cabin Length" className="compare__table__cell compare__table__cell--header">
                                    <div className="compare__table__cell__text">Cabin Length</div>
                                    <img src={cabinLength} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="compare__table-backgrounds">
                        <div className="compare__table-backgrounds__background1" />
                        <div className="compare__table-backgrounds__background2" />

                        <div className="compare__table">
                            {selectedFlights.map((aircraft) => {
                                return (
                                    <React.Fragment key={aircraft.id}>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                "compare__table__cell--title",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            <b>{aircraft.aircraftName}</b>
                                            <br />
                                            {aircraft.category}
                                            <br />
                                            {getDenomination(aircraft.operatorCurrency)}
                                            <NumericFormat
                                                displayType="text"
                                                value={
                                                    aircraft.operatorCurrency
                                                        ? aircraft.price[aircraft.operatorCurrency.toLowerCase()]
                                                        : 0
                                                }
                                                thousandSeparator
                                                decimalScale={0}
                                            />
                                            {aircraft.operatorCurrency && (
                                                <>&nbsp;{aircraft.operatorCurrency.toUpperCase()}</>
                                            )}
                                        </div>

                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.yom || "-"}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.refurbishedYear}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.seats}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.fuelStop}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.luggage}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.cateringOption || "-"}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.toilet}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.ownerApproval === "Y" ? "Required" : "Not Required"}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.wifiOption}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.numberOfPilots}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.flightAttendants === "Y" ? (
                                                <img src={tick} alt="Yes" />
                                            ) : (
                                                <img src={cross} alt="No" />
                                            )}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.pets}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.smokingOption === "Y" ? (
                                                <img src={tick} alt="Yes" />
                                            ) : (
                                                <img src={cross} alt="No" />
                                            )}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            <NumericFormat displayType="text" value={aircraft.co2} decimalScale={2} />T
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.subjectToConditions}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.subjectToWeight === "Y" ? (
                                                <img src={tick} alt="Yes" />
                                            ) : (
                                                <img src={cross} alt="No" />
                                            )}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.headRoom ? `${aircraft.headRoom.replace("m", "")}m` : "-"}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.cabinWidth ? `${aircraft.cabinWidth}m` : "-"}
                                        </div>
                                        <div
                                            className={getClassName([
                                                "compare__table__cell",
                                                aircraft.recommended ? "compare__table__cell--gold" : null,
                                            ])}
                                        >
                                            {aircraft.cabinLength ? `${aircraft.cabinLength}m` : "-"}
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className="wrap">
                    <div className="form-button-wrapper">
                        <Button
                            onClick={navigateBackToQuoteHandler}
                            classNames={["button--full", poweredByCtx.isPoweredBy ? undefined : "button--tertiary"]}
                            animate={true}
                        >
                            Back to Quote
                        </Button>
                    </div>
                </div>
            </div>

            <Modal
                classNames={["modal__content--thin"]}
                modalVisible={showSharePanel}
                closeModal={() => {
                    setShowSharePanel(false);
                }}
            >
                <Share
                    type="flight"
                    endpoint={"/api/frontend/share-quote"}
                    shareRef={getShareRef()}
                    close={() => {
                        setShowSharePanel(false);
                    }}
                    tailNumbers={tailNumbers}
                />
            </Modal>
        </>
    );
};

export default Compare;
